var map = {
	"./All.svg": "GuTI",
	"./All_act.svg": "8Ofw",
	"./Baccarat.svg": "dORA",
	"./Baccarat_act.svg": "MYpA",
	"./Blackjack.svg": "ZcjH",
	"./Blackjack_act.svg": "5kzh",
	"./Fishing.svg": "IZLN",
	"./Fishing_act.svg": "8Ftx",
	"./Live.svg": "NYff",
	"./Live_act.svg": "uH5O",
	"./Lottery.svg": "qEfq",
	"./Lottery_act.svg": "3uNS",
	"./Popular.svg": "N52L",
	"./Popular_act.svg": "tHoD",
	"./Slots.svg": "jKV/",
	"./Slots_act.svg": "jhGB",
	"./Sports.svg": "lOjx",
	"./Sports_act.svg": "Vyqy",
	"./search.svg": "ENHM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "An5a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GamePage \.svg$
// module id = An5a
// module chunks = 1